export default __webpack_public_path__ + "static/media/5.15b0bbab.webp";